import MainLayout from '../layouts/main';
import PaymentVerifyContainer from './container';
import PaymentFailure from './payment-failure';
import useQueryParams from '../../hooks/index/use-query-params';

function PaymentVerifyPage() {
  const { status, code, error } = useQueryParams();

  return (
    <MainLayout>
      {status === '200' ? (
        <PaymentVerifyContainer code={code} />
      ) : (
        <PaymentFailure code={code} error={error} />
      )}
    </MainLayout>
  );
}

export default PaymentVerifyPage;
